﻿shvenergy.quoteresult = (function ($) {
	"use strict";

	var linkIsClicked = false;
	var formCanBeSubmitted = 0;
    var cdnvalue = $("#cdnInput").data("value");
	function validateConfirmForm() {

		if ($("#quoteConfirmForm").length) {
			$("#quoteConfirmForm").validate({
				rules: {
					"Name": "required",
					"LastName": "required",
					"Email": {
						required: true,
						email: true
					},
					"Phone": "required",
					"AddressOne": "required",
					"PostalCode": "required",
					"City": "required"
				},
				messages: {
					"Name": window.quoteFormErrorMessages.frmNameA,
					"LastName": window.quoteFormErrorMessages.frmLastNameA,
					"Email": {
						"required": window.quoteFormErrorMessages.email.required,
						"email": window.quoteFormErrorMessages.email.email
					},
					"Phone": window.quoteFormErrorMessages.phone,
					"AddressOne": window.quoteFormErrorMessages.shipAddress,
					"PostalCode": window.quoteFormErrorMessages.shipZip,
					"City": window.quoteFormErrorMessages.shipCity,
					"frmChkA": window.quoteFormErrorMessages.frmChkA,
					"frmChkB": window.quoteFormErrorMessages.frmChkB
				},
				errorPlacement: function (error, element) {
					var $element = $(element);
					if ($element.is("input[data-role='checkbox']")) {
						error.insertAfter($element.parent("div"));
					} else {
						error.insertAfter(element);
					}
				},
				submitHandler: function (form) {
					//console.log('test');
					/* if(formCanBeSubmitted===0){
	
						$('#quoteConfirmForm').find(':submit').prop('disabled',true);
						$('#quoteConfirmForm').find(':submit').append('<svg class="loading" focusable="false"><use xlink:href="/dist/svgsprite/icons.svg#Loading_16x16"></use></svg>')
						$('#quoteConfirmForm').find(':submit').css('pointer-events','none');
						formCanBeSubmitted++;
					}
					if(formCanBeSubmitted===1){
						submit
					} */

					$('#quoteConfirmForm').find(':submit').prop('disabled', true);
					$('#quoteConfirmForm').find(':submit').find('svg').hide();
                    $('#quoteConfirmForm').find(':submit').append('<svg class="loading" focusable="false" aria-hidden="true" width="16" height="16" viewBox="0 0 16 16"><use xlink:href="' + cdnvalue + '/dist/svgsprite/icons.svg#Loading_16x16"></use></svg>');
					$('#quoteConfirmForm').find(':submit').css('pointer-events', 'none');

					form.submit();
					//console.log('test2');
				}
			});

			/* $('#quoteConfirmForm').on('submit',function(){
				console.log('first submit');
				$('#quoteConfirmForm').find('button').attr('disabled',true);
				$('#quoteConfirmForm').find('button').append('<svg class="loading" focusable="false"><use xlink:href="/dist/svgsprite/icons.svg#Loading_16x16"></use></svg>')
			}); */
		}




	}

	function init() {

		$(document).on("click", ".quote-button", function (e) {

			var link = $(this);

			if (link.attr("target") === "_blank") {
				window.open($(this).attr('href'), 'quotewin');
			} else {

				e.preventDefault();

				if (!linkIsClicked) {
					linkIsClicked = true;
					$(".quote-button").each(function (index) {
						$(this).attr('disabled', true);
					});
					$(this).find('svg').hide();
                    $(this).append('<svg class="loading" focusable="false" aria-hidden="true" width="16" height="16" viewBox="0 0 16 16"><use xlink:href="' + cdnvalue + '/dist/svgsprite/icons.svg#Loading_16x16"></use></svg>');


					window.location = $(this).attr('href');
				}

			}

		});




		//confirm page
		//User Story23858 changed the order in which js is loaded, so now we know that jquery validate is always available
		if (typeof $.validator !== "function") {
			$.getScript("https://cdnjs.cloudflare.com/ajax/libs/jquery-validate/1.17.0/jquery.validate.min.js")
				.done(function (script, textStatus) {
					console.log("Trying to get jquery.validate.min.js from cloudflare: ", textStatus);
					validateConfirmForm();
				})
				.fail(function (jqxhr, settings, exception) {
					console.log("Could not load jquery.validate.min.js from cloudflare CDN :-(");
				});
		} else {
			validateConfirmForm();
		}

	}

	init();

})(jQuery);